import { CounterpartyAddress } from "@common/schemas/counterpartyAddress.schema";
import { CounterpartyContact } from "@common/schemas/counterpartyContact.schema";

// Copy-global clones a shared counterparty's books onto a fresh local copy,
// preserving every field except the id (see `cloneBooksTo`). A child action
// started against the global row therefore holds a stale id once the copy runs;
// match it to its local clone by structural equality so the mutation targets the
// local row instead of returning Not Found. Rows that are identical apart from
// the id are interchangeable, so a full-field match stays correct even when two
// rows share the same `createdAt`.

function isSameInstant(a: Date, b: Date): boolean {
    return a.getTime() === b.getTime();
}

export function matchClonedContact(
    source: CounterpartyContact,
    candidates: CounterpartyContact[],
): CounterpartyContact | undefined {
    return candidates.find(
        (candidate) =>
            isSameInstant(candidate.createdAt, source.createdAt) &&
            candidate.isPrimary === source.isPrimary &&
            candidate.label === source.label &&
            candidate.title === source.title &&
            candidate.firstName === source.firstName &&
            candidate.middleName === source.middleName &&
            candidate.lastName === source.lastName &&
            candidate.suffix === source.suffix &&
            candidate.email === source.email &&
            candidate.phoneNumber === source.phoneNumber,
    );
}

export function matchClonedAddress(
    source: CounterpartyAddress,
    candidates: CounterpartyAddress[],
): CounterpartyAddress | undefined {
    return candidates.find(
        (candidate) =>
            isSameInstant(candidate.createdAt, source.createdAt) &&
            candidate.isPrimary === source.isPrimary &&
            candidate.label === source.label &&
            candidate.street === source.street &&
            candidate.street2 === source.street2 &&
            candidate.city === source.city &&
            candidate.postalCode === source.postalCode &&
            candidate.state === source.state &&
            candidate.country === source.country,
    );
}
